import { useEffect, useState } from 'react'

export type Locale = 'uk' | 'en'

const STORAGE_KEY = 'eudokia.locale'

const EN: Record<string, string> = {
  Кабінет: 'Cabinet',
  Вийти: 'Sign out',
  'Режим панелі': 'Pane mode',
  'Ревʼю': 'Review',
  Клаузи: 'Clauses',
  Реквізити: 'Company details',
  Асистент: 'Assistant',
  'Плейбук або реквізити оновлені в кабінеті. Поточний результат застарів.':
    'The playbook or company details were updated in the cabinet. This result is out of date.',
  'Перевірити знову': 'Review again',
  Сховати: 'Hide',
  'Невірний код.': 'Wrong code.',
  'Не вдалося зʼєднатися з бекендом.': 'Could not reach the server.',
  'Надішлемо одноразовий код на цю пошту.': 'We will send a one-time code to this email.',
  'Код надіслано на {email}. Немає листа — перевірте «Спам».':
    'The code was sent to {email}. If it is missing, check Spam.',
  'Чекайте…': 'Please wait…',
  'Надіслати код': 'Send code',
  Увійти: 'Sign in',
  'Код з листа': 'Code from the email',
  'Змінити пошту': 'Change email',
  'Ця версія Word не підтримує потрібні можливості (WordApi 1.4). Панель ревю недоступна.':
    'This version of Word does not support the required features (WordApi 1.4). The review pane is unavailable.',
  'Скористайтеся веб-кабінетом і завантажте документ для перевірки файлом.':
    'Use the web cabinet and upload the document for a file review.',
  Відхилення: 'Deviation',
  'Відсутнє положення': 'Missing clause',
  Нетипове: 'Unusual',
  Повторювана: 'Recurring',
  'без привʼязки': 'not anchored',
  'Не вдалося знайти пункт — документ змінився?':
    'Could not find the clause — did the document change?',
  'Коментар уже вставлено. Додати ще один?': 'A comment is already there. Add another?',
  'Коментар вставлено': 'Comment inserted',
  'Пункт не знайдено. Обґрунтування скопійовано в буфер.':
    'Clause not found. The rationale was copied to the clipboard.',
  'Не вдалося вставити коментар. Обґрунтування скопійовано в буфер.':
    'Could not insert the comment. The rationale was copied to the clipboard.',
  'Не вдалося вставити коментар і скопіювати текст.':
    'Could not insert the comment or copy the text.',
  'Правку застосовано до виділеного фрагмента': 'The edit was applied to the selection.',
  'Текст вставлено новим абзацом у позицію курсора':
    'The text was inserted as a new paragraph at the cursor.',
  'Вставлено в позицію курсора': 'Inserted at the cursor.',
  'Не вдалося вставити. Формулювання скопійовано — вставте вручну.':
    'Could not insert. The wording was copied — paste it by hand.',
  'Не вдалося вставити правку.': 'Could not insert the edit.',
  'ШІ-правка готова — перевірте текст і натисніть «Застосувати»':
    'The AI revision is ready — check the text and press Apply.',
  'Підставлено формулювання з плейбука — перевірте й натисніть «Застосувати»':
    'Playbook wording was inserted — check it and press Apply.',
  'Не вдалося згенерувати правку.': 'Could not generate the revision.',
  'Сховано до кінця цієї перевірки': 'Hidden until this review ends',
  'Рекомендоване місце вставки (не точна локація)':
    'Suggested insert point (not an exact location)',
  'Показати в документі': 'Show in the document',
  'Пункт без прив’язки': 'Clause is not anchored',
  Додавання: 'Addition',
  Правка: 'Edit',
  Висока: 'High',
  Середня: 'Medium',
  Низька: 'Low',
  'Затверджене положення': 'Approved wording',
  'Текст правки': 'Edit text',
  'Ще коментар': 'Another comment',
  Коментар: 'Comment',
  'Сховати редактор': 'Hide editor',
  Редагувати: 'Edit',
  'Правильне зауваження': 'Correct finding',
  'Хибне зауваження': 'False positive',
  'Відгук збережено': 'Feedback saved',
  'Не вдалося зберегти відгук': 'Could not save the feedback',
  'Перевірено весь доступний текст': 'The available text was checked',
  'Цитати перевірено за текстом договору': 'Quotes were checked against the contract',
  'Поставте курсор у потрібну колонку. Текст з’явиться новим абзацом у цій точці.':
    'Place the cursor in the right column. The text appears as a new paragraph there.',
  'Виділіть текст, щоб замінити його, або поставте курсор, щоб вставити. Клік по назві пункту виділяє його.':
    'Select text to replace it, or place the cursor to insert. Click the clause name to select it.',
  'Показати деталі': 'Show details',
  'Правку вже вставляли в цій сесії. Повторне «Застосувати» вставить її туди, де зараз курсор.':
    'This edit was already inserted in this session. Apply again inserts it where the cursor is now.',
  Застосувати: 'Apply',
  Ігнорувати: 'Ignore',
  'ШІ-правка': 'AI revision',
  'Підсумувати ключові правки': 'Summarise the key edits',
  'Перевірити визначені терміни': 'Check defined terms',
  'Витягнути ключові умови': 'Extract key terms',
  'Знайти плейсхолдери': 'Find placeholders',
  'Перекласти правки': 'Translate the edits',
  'Асистент недоступний.': 'The assistant is unavailable.',
  'Наприклад: який строк оплати в цьому договорі?':
    'For example: what is the payment term in this contract?',
  'Надіслати запитання з поля вище': 'Send the question from the field above',
  'Спочатку введіть запитання': 'Enter a question first',
  'Надсилаю…': 'Sending…',
  Надіслати: 'Send',
  'Привіт! Я асистент EUDOKIA. Чим допомогти?': 'Hello. I am the EUDOKIA assistant. How can I help?',
  'Що аналізувати': 'What to analyse',
  'Поточний файл': 'Current file',
  'Виділений фрагмент': 'Selection',
  'Своє запитання': 'Your question',
  'Або оберіть готову дію — вона запуститься одразу':
    'Or pick a ready action — it runs immediately',
  'обовʼязкова клауза': 'required clause',
  заборона: 'prohibition',
  обмеження: 'limit',
  'Нічого не знайдено. Додайте затверджені формулювання в плейбук.':
    'Nothing found. Add approved wording in the playbook.',
  'Пошук не вдався': 'Search failed',
  'Вставлено в документ зі змінами, що відстежуються.': 'Inserted into the document as a tracked change.',
  'Не вдалося вставити. Текст скопійовано — вставте вручну.':
    'Could not insert. The text was copied — paste it by hand.',
  'Не вдалося вставити формулювання.': 'Could not insert the wording.',
  'конфіденційність, оплата, відповідальність': 'confidentiality, payment, liability',
  'Запит пошуку клаузи': 'Clause search query',
  'Шукаю…': 'Searching…',
  Шукати: 'Search',
  Згорнути: 'Collapse',
  'Показати все': 'Show all',
  'Шукайте затверджені формулювання плейбука і вставляйте в договір.':
    'Search approved playbook wording and insert it into the contract.',
  'Пошук клаузи': 'Clause search',
  шаблон: 'template',
  Вставити: 'Insert',
  'Вставити фрагмент': 'Insert snippet',
  'Не вдалося завантажити реквізити': 'Could not load company details',
  Компанія: 'Company',
  'блок реквізитів': 'company block',
  'Оновлюю…': 'Refreshing…',
  Оновити: 'Refresh',
  Повторити: 'Try again',
  'Завантаження реквізитів…': 'Loading company details…',
  'Реквізити компанії ще не заповнені.': 'Company details are not filled in yet.',
  'Відкрийте кабінет, розділ «Реквізити», збережіть дані — і вони зʼявляться тут для вставки в документ.':
    'Open the cabinet, Company details, save the data — it will show up here to insert into the document.',
  'Відкрити кабінет': 'Open the cabinet',
  'Немає компанії для вставки.': 'There is no company to insert.',
  'Поставте курсор у документ і вставте весь блок або окреме поле. Вставка йде зі змінами, що відстежуються.':
    'Place the cursor in the document and insert the whole block or one field. Insertion is a tracked change.',
  'Немає погоджених правил цього типу. Погодьте правило в Playbook.':
    'No approved rules of this type. Approve a rule in the Playbook.',
  'Погоджені правила виключені з порівняння. Увімкніть «Порівнювати» в Playbook.':
    'Approved rules are excluded from comparison. Turn Compare back on in the Playbook.',
  'Ліміт ревʼю на цьому тарифі вичерпано. Оновіть план у кабінеті.':
    'The review limit on this plan is used up. Upgrade the plan in the cabinet.',
  'Уже виконується ревʼю. Дочекайтеся завершення.':
    'A review is already running. Wait for it to finish.',
  'Не вдалося розібрати документ.': 'Could not read the document.',
  'Зʼєднання розірвалось.': 'The connection dropped.',
  'Не вдалося прочитати документ. Збережіть файл і вимкніть «Захищений режим», якщо він увімкнений.':
    'Could not read the document. Save the file and turn off Protected View if it is on.',
  'Помилка ревʼю.': 'Review error.',
  'Документ завеликий (ліміт 20 МБ).': 'The document is too large (20 MB limit).',
  'Формат документа не підтримується.': 'This document format is not supported.',
  'Ліміт ревʼю вичерпано або надто багато одночасних запитів.':
    'The review limit is used up, or too many reviews are running.',
  'Мережева помилка.': 'Network error.',
  'Плейбук порожній — додайте правила в кабінеті.':
    'The playbook is empty — add rules in the cabinet.',
  'У цьому типі': 'In this type',
  'У плейбуку': 'In the playbook',
  'У плейбуку {n} непогоджених правил. Їх не враховано.':
    'The playbook has {n} unapproved rules. They were not included.',
  'У цьому типі {n} непогоджених правил. Їх не враховано.':
    'This type has {n} unapproved rules. They were not included.',
  'Натисніть «Перевірити», щоб звірити документ із плейбуком (відхилення, відсутні положення, нетипове, повтори).':
    'Press Review to check the document against the playbook (deviations, missing clauses, unusual terms, repeats).',
  'Усі ({n})': 'All ({n})',
  'Плейбук ({n})': 'Playbook ({n})',
  'Архів ({n})': 'Archive ({n})',
  'Бракує: {items}': 'Missing: {items}',
  'Читаю документ…': 'Reading the document…',
  'Надсилаю на сервер…': 'Sending to the server…',
  'SSE відповідь без тіла': 'The review stream had no body',
  'Виділіть текст, щоб замінити його, або поставте курсор, щоб вставити. Клік по назві пункту виділяє його в документі.':
    'Select text to replace it, or place the cursor to insert. Click the clause name to select it in the document.',
  'Виконується…': 'Running…',
  Перевірити: 'Review',
  'Шар результату': 'Result layer',
  'Читаю документ': 'Reading the document',
  'Надсилаю на сервер': 'Sending to the server',
  'Готово. Відхилень: {t1}, відсутніх: {t2}, нетипових: {t3}, повторів: {t4}.':
    'Done. Deviations: {t1}, missing: {t2}, unusual: {t3}, recurring: {t4}.',
  'Ревю неповне. Перегляньте неперевірені правила у вкладці «Плейбук».':
    'The review is incomplete. See the unchecked rules on the Playbook tab.',
  'Тип договору': 'Contract type',
  'Усі типи': 'All types',
  Скасувати: 'Cancel',
  Звіт: 'Report',
  Правки: 'Fixes',
  Плейбук: 'Playbook',
  'Що треба виправити в цьому файлі: порушення або відсутні умови плейбука.':
    'What to fix in this file: breaches or missing playbook terms.',
  '[Відсутнє положення]': '[Missing clause]',
  '[Нетипове положення]': '[Unusual clause]',
  '[Повторювана проблема]': '[Recurring issue]',
  '[Відхилення]': '[Deviation]',
  'Помилка {status}': 'Error {status}',
  'вставка біля {section}': 'insert near {section}',
  'Компанія {n}': 'Company {n}',
  'Вставлено: {label}.': 'Inserted: {label}.',
  'Не вдалося вставити. «{label}» скопійовано — вставте вручну.':
    'Could not insert. “{label}” was copied — paste it by hand.',
  'Не вдалося вставити «{label}».': 'Could not insert “{label}”.',
  'Буде застосовано правил: {n}.': 'Rules that will run: {n}.',
  Відсутнє: 'Missing',
  Повтор: 'Recurring',
  Підтверджено: 'Confirmed',
  Порушено: 'Breached',
  Частково: 'Partial',
  'Не застосовується': 'Does not apply',
  'Потребує перевірки': 'Needs review',
  'Помилка перевірки': 'Check failed',
  'Не підтверджено': 'Not confirmed',
  'Це правило вже порушувалось у {count} інших договорах':
    'This rule was already breached in {count} other contracts',
  'Це правило вже порушувалось в інших договорах':
    'This rule was already breached in other contracts',
  '# Звіт ревʼю EUDOKIA': '# EUDOKIA review report',
  'Увага: ревю неповне; є неперевірені правила.':
    'Note: the review is incomplete; some rules were not checked.',
  'Відхилень: {t1}, відсутніх: {t2}, нетипових: {t3}, повторів: {t4}.':
    'Deviations: {t1}, missing: {t2}, unusual: {t3}, recurring: {t4}.',
  'Не вдалося отримати відповідь із підтвердженими цитатами.':
    'Could not get an answer with confirmed quotes.',
  'Доказів недостатньо або незалежна перевірка не підтвердила висновок.':
    'The evidence is not enough, or a second check did not confirm the result.',
  'Потрібне узгодження умов між частинами документа.':
    'Terms in different parts of the document need to be reconciled.',
  'Вичерпано час перевірки.': 'The review ran out of time.',
  'Досягнуто ліміту витрат на перевірку.': 'The review cost limit was reached.',
  'Досягнуто ліміту запитів.': 'The request limit was reached.',
  'Не налаштовано тариф моделі для контролю витрат.':
    'The model price is not configured for cost control.',
  'Неоднозначні число, одиниця або умова відліку.':
    'The number, unit, or start event is ambiguous.',
  'У плейбуку знайдено суперечливі правила.': 'The playbook has conflicting rules.',
  'Перевірено весь доступний текст документа.': 'The available text of the document was checked.',
  'Документ не містить тексту для перевірки.': 'The document has no text to check.',
  'У правила немає тексту вимоги — ревʼю не може його шукати.':
    'The rule has no requirement text, so the review cannot search for it.',
  'Потребує ручної перевірки.': 'Needs a lawyer to check it.',
  'Перевіряю крок {done} з {total}': 'Checking step {done} of {total}',
  'Готую перевірку… кроків: {total}': 'Preparing the review… steps: {total}',
  'Аналізую документ…': 'Reading the document…',
  'Уже {sec} с. Не закривайте панель — великі документи перевіряються довше.':
    'Already {sec} s. Keep the pane open — large documents take longer.',
  'Не закривайте панель, поки йде перевірка.': 'Keep the pane open while the review runs.',
  'Відповідаю на запитання': 'Answering the question',
  'Підсумовую ключові правки': 'Summarising the key edits',
  'Перевіряю визначені терміни': 'Checking defined terms',
  'Витягаю ключові умови': 'Extracting key terms',
  'Шукаю плейсхолдери': 'Looking for placeholders',
  'Перекладаю правки': 'Translating the edits',
  'Готую відповідь': 'Preparing the answer',
  'Уже {sec} с. Не закривайте панель — відповідь ще формується.':
    'Already {sec} s. Keep the pane open — the answer is still being written.',
  'Готую відповідь. Не закривайте панель.': 'Preparing the answer. Keep the pane open.',
  'Сесію завершено. Увійдіть знову.': 'The session ended. Sign in again.',
  Архів: 'Archive',
  'Вставити блок': 'Insert block',
  'Блок реквізитів': 'Company block',
  'Окремі поля': 'Individual fields',
  'Усі': 'All',
  'Сповіщення ({solved}/{open} вирішено)': 'Notices ({solved}/{open} resolved)',
  'Немає знахідок для цього фільтра.': 'No findings for this filter.',
  'Немає правил для цього фільтра.': 'No rules for this filter.',
  'Немає правил плейбука в цьому ревʼю.': 'This review has no playbook rules.',
  'Нетипових умов не знайдено.': 'No unusual terms were found.',
  'Умови, яких немає у вашому плейбуку. Це не порушення — просто звернути увагу.':
    'Terms that are not in your playbook. Not a breach — just something to notice.',
  'Чи знайшлось у документі підтвердження кожного правила. Це не список правок.':
    'Whether the document confirms each rule. This is not a list of edits.',
  'Порушень плейбука не знайдено. Нетипове: {n}, покриття правил — у вкладці «Плейбук».':
    'No playbook breaches. Unusual: {n}. Rule coverage is on the Playbook tab.',
  'Документ змінився. Результати застаріли — запустіть ревю повторно.':
    'The document changed. The results are stale — run the review again.',
  'Замінити попередній результат новим ревʼю?': 'Replace the previous result with a new review?',
  'Потребує ручної перевірки': 'Needs a lawyer to check it',
  'правил. Їх не враховано.': 'rules. They were not included.',
}

function readLocale(): Locale {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'en' ? 'en' : 'uk'
  } catch {
    return 'uk'
  }
}

let locale: Locale = readLocale()
const listeners = new Set<() => void>()

export function getLocale(): Locale {
  return locale
}

export function setLocale(next: Locale): void {
  locale = next
  try {
    localStorage.setItem(STORAGE_KEY, next)
  } catch {
    // Private mode can block storage. The in-memory choice still applies.
  }
  document.documentElement.lang = next
  listeners.forEach((fn) => fn())
}

export function useLocale(): Locale {
  const [value, setValue] = useState(locale)
  useEffect(() => {
    const fn = () => setValue(locale)
    listeners.add(fn)
    return () => {
      listeners.delete(fn)
    }
  }, [])
  return value
}

export function t(uk: string, vars?: Record<string, string | number>): string {
  let text = locale === 'en' ? (EN[uk] ?? uk) : uk
  if (vars) {
    for (const [key, value] of Object.entries(vars)) {
      text = text.replaceAll(`{${key}}`, String(value))
    }
  }
  return text
}

export function LanguageSwitch({
  onPick,
}: {
  onPick?: (next: Locale) => void
}) {
  const current = useLocale()
  return (
    <button
      type="button"
      className="linkish"
      onClick={() => {
        const next: Locale = current === 'en' ? 'uk' : 'en'
        setLocale(next)
        onPick?.(next)
      }}
    >
      {current === 'en' ? 'UA' : 'EN'}
    </button>
  )
}

document.documentElement.lang = locale
